var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":_vm.dark ? 'white' : 'primary'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }